(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('alerts', {
                parent: 'app',
                url: '/alerts',
                data: {
                    pageTitle: 'Axenteev | Alertes',
                    authorities: ['ROLE_COMMERCIAL', 'ROLE_DG', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/alerts/alerts.html',
                        controller: 'AlertsController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('alerts.new', {
                parent: 'alerts',
                url: '/new?type&id&name',
                data: {
                    authorities: ['ROLE_COMMERCIAL', 'ROLE_DG', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/alerts/alerts-dialog.html',
                        controller: 'AlertsNewController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            entity: function () {
                                var entity = {
                                    "active": true
                                };
                                if ($stateParams.type === "company" || $stateParams.type === "collectivity") {
                                    entity.type = "organisation";
                                    entity["organisation"] = {
                                        id: $stateParams.id,
                                        type: $stateParams.type
                                    };
                                } else {
                                    // Profile
                                    entity.type = $stateParams.type;
                                    entity[$stateParams.type] = {
                                        id: $stateParams.id
                                    };
                                }
                                return entity;
                            }
                        }
                    }).result.then(function() {
                        $state.go('alerts', null, { reload: 'alerts' });
                    }, function() {
                        $state.go('alerts');
                    });
                }]
            });
    }
})();
